import React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  EmployeesEmployeeQuickViewFragment,
  PerformanceV2InlineAccessFragment,
} from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

import { EmployeeQuickView } from 'modules/employees/components/EmployeeQuickView'

interface InlineAccessProps {
  access: Omit<PerformanceV2InlineAccessFragment, 'avatar'> & {
    avatar?: PerformanceV2InlineAccessFragment['avatar']
  }
  hideAvatar?: boolean
}

interface QuickViewProps {
  employee?: EmployeesEmployeeQuickViewFragment | null
  children: React.ReactNode
}

const QuickView: React.FC<QuickViewProps> = ({ employee, children }) => {
  if (!employee) return <>{children}</>
  return <EmployeeQuickView employee={employee}>{children}</EmployeeQuickView>
}

export const InlineAccess: React.FC<InlineAccessProps> = ({ access, hideAvatar }) => {
  return (
    <QuickView employee={access.employee}>
      <Box inline>
        <Box gap="s8" flexDirection="row" alignItems="center">
          {!hideAvatar && (
            <Avatar
              label={access.fullName}
              url={access.avatar && buildUrl(access.avatar)}
              size="s32"
            />
          )}
          <Text.Normal size="300" whiteSpace="nowrap" ellipsis title={null}>
            {access.fullName}
          </Text.Normal>
        </Box>
      </Box>
    </QuickView>
  )
}
